import {Button} from "omoplay";
import {useEffect, useState} from "react";
import {postProjectPassword} from "../../../api/project/project.api";
import InputGroup from "../InputGroup";
import PasswordType from "../PasswordType";


const ProjectDetailBenefitPassword = ({projectId, passwordType, benefitPassword}) => {
    const [type, setType] = useState(passwordType)
    const [password, setPassword] = useState(benefitPassword)
    const [disabled, setDisabled] = useState(false)

    const onSubmit = (password) => {
        postProjectPassword(projectId, password, type).then(() => {
            alert("적용 되었습니다.")
        })
    }

    useEffect(() => {
        setType(passwordType)
        setPassword(benefitPassword)
    }, [passwordType, benefitPassword])

    return (
        <InputGroup label={
            <div className="flex-align-center justify-between">
                <div className="text-[16px]">혜택 사용 비밀번호</div>
                <div className="flex-align-center gap-4">
                    <Button variants="dark" value="적용하기" onClick={() => onSubmit(password)} disabled={disabled} />
                </div>
            </div>
        } description="고객이 혜택을 사용할 때 직원 확인용 비밀번호를 입력받습니다.">
            <PasswordType passwordType={type}
                          benefitPassword={password}
                          onChangePasswordType={setType}
                          onChangePassword={setPassword}
                          onChangeValid={(valid) => setDisabled(valid)}
            />
            {/*
              🔴 종전 설명은 "(직원 확인, 카카오 선물하기만 적용)" 이었다. **정반대다.**
                 - 비밀번호는 매장에서 직접 쓰는 혜택(쿠폰/코드/배송)에 적용된다.
                 - 카카오 선물하기는 2026-09-03 부터 이 설정과 무관하게 당첨 즉시 발송된다
                   (EventExternalService.processBenefitResult). 기프티콘은 카카오톡으로 바로 전달되는 것이
                   전제라 현장 비밀번호가 성립하지 않는다.
                 종전 문구를 그대로 두면 담당자가 "카카오 선물하기를 막으려고" 비밀번호를 켠다.
            */}
            <div className="mt-2 text-xs font-semibold text-amber-700 leading-relaxed">
                주의: 카카오 선물하기 혜택은 이 비밀번호 설정과 관계없이 당첨 즉시 발송됩니다.
            </div>
        </InputGroup>
    )
}

export default ProjectDetailBenefitPassword